"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WSRequest = exports.WSChannel = void 0;
var WSChannel;
(function (WSChannel) {
    WSChannel["candlesticks"] = "candlesticks";
    WSChannel["books"] = "books";
    WSChannel["recent_trades"] = "recent_trades";
    WSChannel["orders"] = "orders";
    WSChannel["orders_by_market"] = "orders_by_market";
    WSChannel["balances"] = "balances";
    WSChannel["account_trades"] = "account_trades";
    WSChannel["account_trades_by_market"] = "account_trades_by_market";
    WSChannel["market_stats"] = "market_stats";
    WSChannel["market_stats_by_market"] = "market_stats_by_market";
    WSChannel["leverages"] = "leverages";
    WSChannel["leverages_by_market"] = "leverages_by_market";
    WSChannel["positions"] = "positions";
    WSChannel["positions_by_market"] = "positions_by_market";
    WSChannel["pools"] = "pools";
    WSChannel["pools_by_id"] = "pools_by_id";
    WSChannel["commitments"] = "commitments";
})(WSChannel = exports.WSChannel || (exports.WSChannel = {}));
var WSRequest;
(function (WSRequest) {
    WSRequest["MarketStats"] = "get_market_stats";
    WSRequest["OrderHistory"] = "get_order_history";
    WSRequest["RecentTrades"] = "get_recent_trades";
    WSRequest["Candlesticks"] = "get_candlesticks";
    WSRequest["OpenOrders"] = "get_open_orders";
    WSRequest["AccountTrades"] = "get_account_trades";
    WSRequest["Leverages"] = "get_leverages";
    WSRequest["Positions"] = "get_positions";
    WSRequest["OpenPositions"] = "get_open_positions";
    WSRequest["ClosedPosition"] = "get_closed_positions";
    WSRequest["Balances"] = "get_balances";
    WSRequest["OrderBook"] = "get_orderbook";
    WSRequest["Pools"] = "get_pools";
    WSRequest["Commitments"] = "get_commitments";
})(WSRequest = exports.WSRequest || (exports.WSRequest = {}));
